import React, { useState, useRef } from 'react';
import Layout from '../components/Layout';
import { FaCashRegister, FaCheckCircle, FaArrowLeft } from 'react-icons/fa';

const BalanceRecharge = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [paymentMethod, setPaymentMethod] = useState('credit');
  const [rechargeAmount, setRechargeAmount] = useState('');
  const [associadoData, setAssociadoData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  
  // Use ref para o input em vez de state
  const amountInputRef = useRef(null);

  const mockAssociadoData = {
    nome: "João Silva Santos",
    cota: "1234",
    digito: "5",
    documento: "123.456.789-00",
    foto: null
  };

  const handlePaymentMethodChange = (method) => {
    setPaymentMethod(method);
  };

  const handleContinue = () => {
    const value = amountInputRef.current ? amountInputRef.current.value : rechargeAmount;
    console.log({
      paymentMethod,
      rechargeAmount: value
    });
    alert(`Recarga de R$ ${value} processada com sucesso!`);
  };

  const handleScanComplete = () => {
    setIsLoading(true);
    setTimeout(() => {
      setAssociadoData(mockAssociadoData);
      setIsLoading(false);
      setCurrentStep(2);
    }, 2000);
  };

  const handleConfirmAssociado = () => {
    setCurrentStep(3);
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  // Input controlado separadamente para evitar rerenders
  const AmountInput = () => {
    return (
      <input 
        ref={amountInputRef}
        type="text" 
        placeholder="R$ 0,00" 
        defaultValue={rechargeAmount}
        style={styles.amountInput}
      />
    );
  };

  const StepIndicator = () => (
    <div style={styles.stepIndicator}>
      <div style={{
        ...styles.stepCircle,
        ...(currentStep >= 1 ? styles.stepCircleActive : styles.stepCircleInactive)
      }}>1</div>
      <div style={{
        ...styles.stepLine,
        ...(currentStep >= 2 ? styles.stepLineActive : {})
      }}></div>
      <div style={{
        ...styles.stepCircle,
        ...(currentStep >= 2 ? styles.stepCircleActive : styles.stepCircleInactive)
      }}>2</div>
      <div style={{
        ...styles.stepLine,
        ...(currentStep >= 3 ? styles.stepLineActive : {})
      }}></div>
      <div style={{
        ...styles.stepCircle,
        ...(currentStep >= 3 ? styles.stepCircleActive : styles.stepCircleInactive)
      }}>3</div>
    </div>
  );

  const Step1Leitura = () => (
    <div>
      <StepIndicator />
      <div style={styles.scanContainer}>
        <h2 style={styles.title}>Leitura do Associado</h2>
        <div style={styles.scanIcon}>
          {isLoading ? (
            <div style={styles.loadingSpinner}>
              <div style={styles.spinner}></div>
            </div>
          ) : (
            <div style={styles.readyForScan}>
              <span style={{ fontSize: '60px', marginBottom: '10px' }}>💳</span>
              <p style={{ fontSize: '14px', color: '#666' }}>Pronto para leitura</p>
            </div>
          )}
        </div>
        <div style={styles.scanInstructions}>
          <p><strong>Instruções para leitura:</strong></p>
          <p>1. Utilize a maquininha para ler o cartão do associado ou QR Code da carteirinha digital</p>
          <p>2. Aproxime o cartão ou QR Code do leitor</p>
          <p>3. Aguarde o sinal de confirmação</p>
          <p>4. Os dados do associado serão carregados automaticamente</p>
        </div>
        <button 
          style={styles.continueButton}
          onClick={handleScanComplete}
          disabled={isLoading}
        >
          {isLoading ? 'LENDO...' : 'SIMULAR LEITURA (CONTINUAR)'}
        </button>
      </div>
    </div>
  );

  const Step2Confirmacao = () => {
    return (
      <div>
        <StepIndicator />
        <button style={styles.backButton} onClick={handleBack}>
          <FaArrowLeft /> Voltar
        </button>
        
        <h2 style={styles.title}>Confirmação do Associado</h2>
        
        <div style={styles.confirmationCard}>
          <div style={styles.cardHeader}>
            <h2 style={styles.cardTitle}>Carteirinha de Associado</h2>
          </div>
          
          <div style={styles.cardBody}>
            <div style={styles.photoContainer}>
              <div style={styles.photoSpaceLarge}>
                <div style={styles.photoPlaceholderLarge}>Foto</div>
              </div>
            </div>
            
            <div style={styles.infoSection}>
              <div style={styles.infoContainer}>
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>Nome:</span>
                  <span style={styles.infoValue}>{associadoData.nome}</span>
                </div>
                
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>Cota:</span>
                  <span style={styles.infoValue}>{associadoData.cota}-{associadoData.digito}</span>
                </div>
                
                <div style={styles.infoRow}>
                  <span style={styles.infoLabel}>CPF:</span>
                  <span style={styles.infoValue}>{associadoData.documento}</span>
                </div>
              </div>
            </div>
          </div>
          
          <div style={styles.cardFooter}>
            <p style={styles.footerText}>Associado identificado - Confirme os dados acima</p>
          </div>
        </div>
        
        <button 
          style={styles.continueButton}
          onClick={handleConfirmAssociado}
        >
          CONFIRMAR ASSOCIADO
        </button>
      </div>
    );
  };

  const Step3Pagamento = () => (
    <div>
      <StepIndicator />
      <button style={styles.backButton} onClick={handleBack}>
        <FaArrowLeft /> Voltar
      </button>
      
      <h1 style={styles.title}>Recarga de Saldo</h1>
      
      <div style={styles.paymentContainer}>
        <div style={styles.step}>
          <span style={styles.stepNumber}><b>1.</b> </span>
          <span style={styles.stepText}>Selecione a forma de pagamento:</span>
        </div>
        
        <div style={styles.paymentMethods}>
          <div 
            style={{
              ...styles.paymentOption,
              ...(paymentMethod === 'credit' ? styles.paymentOptionSelected : {})
            }}
            onClick={() => handlePaymentMethodChange('credit')}
          >
            <input 
              type="radio" 
              id="credit" 
              name="paymentMethod" 
              checked={paymentMethod === 'credit'}
              onChange={() => {}}
              style={styles.radioInput}
            />
            <label htmlFor="credit">Cartão crédito</label>
          </div>
          
          <div 
            style={{
              ...styles.paymentOption,
              ...(paymentMethod === 'debit' ? styles.paymentOptionSelected : {})
            }}
            onClick={() => handlePaymentMethodChange('debit')}
          >
            <input 
              type="radio" 
              id="debit" 
              name="paymentMethod" 
              checked={paymentMethod === 'debit'}
              onChange={() => {}}
              style={styles.radioInput}
            />
            <label htmlFor="debit">Cartão débito</label>
          </div>
          
          <div 
            style={{
              ...styles.paymentOption,
              ...(paymentMethod === 'cash' ? styles.paymentOptionSelected : {})
            }}
            onClick={() => handlePaymentMethodChange('cash')}
          >
            <input 
              type="radio" 
              id="cash" 
              name="paymentMethod" 
              checked={paymentMethod === 'cash'}
              onChange={() => {}}
              style={styles.radioInput}
            />
            <label htmlFor="cash">Dinheiro</label>
          </div>
        </div>
        
        <div style={styles.step}>
          <span style={styles.stepNumber}><b>2.</b> </span>
          <span style={styles.stepText}>Valor da recarga do saldo:</span>
        </div>
        
        <div>
          <AmountInput />
        </div>
      </div>
      
      <button 
        style={styles.continueButton}
        onClick={handleContinue}
      >
        FINALIZAR RECARGA
      </button>
    </div>
  );

  return (
    <Layout title="Recarga de Saldo" icon={FaCashRegister}>
      <div style={styles.container}>
        {currentStep === 1 && <Step1Leitura />}
        {currentStep === 2 && <Step2Confirmacao />}
        {currentStep === 3 && <Step3Pagamento />}
      </div>
    </Layout>
  );
};

const styles = {
  container: {
    maxWidth: '400px',
    margin: '0 auto',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    backgroundColor: 'white',
    borderRadius: '10px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    minHeight: '500px',
    marginBottom: '40px'
  },
  title: {
    textAlign: 'center',
    color: '#333',
    marginBottom: '30px',
    fontSize: '24px',
    fontWeight: 'bold'
  },
  stepIndicator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30px',
    gap: '10px'
  },
  stepCircle: {
    width: '30px',
    height: '30px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 'bold',
    fontSize: '14px'
  },
  stepCircleActive: {
    backgroundColor: '#4CAF50',
    color: 'white'
  },
  stepCircleInactive: {
    backgroundColor: '#ddd',
    color: '#666'
  },
  stepLine: {
    width: '40px',
    height: '2px',
    backgroundColor: '#ddd'
  },
  stepLineActive: {
    backgroundColor: '#4CAF50'
  },
  backButton: {
    backgroundColor: 'transparent',
    border: 'none',
    color: '#09448C',
    fontSize: '16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginBottom: '20px',
    fontWeight: 'bold'
  },
  scanContainer: {
    textAlign: 'center',
    padding: '20px 0'
  },
  scanIcon: {
    width: '120px',
    height: '120px',
    margin: '0 auto 30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  loadingSpinner: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
  },
  spinner: {
    width: '50px',
    height: '50px',
    border: '5px solid #f3f3f3',
    borderTop: '5px solid #4CAF50',
    borderRadius: '50%',
    animation: 'spin 1s linear infinite',
  },
  readyForScan: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  scanInstructions: {
    marginBottom: '30px',
    fontSize: '16px',
    color: '#333',
    lineHeight: '1.5',
    textAlign: 'left'
  },
  confirmationCard: {
    width: '100%',
    maxWidth: '400px',
    backgroundColor: '#fff',
    borderRadius: '15px',
    boxShadow: '0 10px 20px rgba(51, 51, 51, 0.3)',
    overflow: 'hidden',
    border: '1px solid #e0e0e0',
    fontFamily: '"Montserrat", sans-serif',
    margin: '0 auto 30px'
  },
  cardHeader: {
    backgroundColor: '#2c3e50',
    color: '#fff',
    padding: '15px 20px',
    textAlign: 'center',
  },
  cardTitle: {
    margin: 0,
    fontSize: '1.4rem',
    fontWeight: '500',
  },
  cardBody: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
  },
  photoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '20px'
  },
  photoSpaceLarge: {
    width: '120px',
    height: '150px',
    backgroundColor: '#f5f5f5',
    border: '1px dashed #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
  },
  photoPlaceholderLarge: {
    color: '#999',
    fontSize: '14px',
  },
  infoSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  infoContainer: {
    flex: 1,
  },
  infoRow: {
    marginBottom: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  infoLabel: {
    fontWeight: 'bold',
    color: '#2c3e50',
    marginRight: '10px',
    minWidth: '100px',
    marginBottom: '5px',
    fontSize: '14px'
  },
  infoValue: {
    color: '#333',
    wordBreak: 'break-word',
    fontSize: '14px'
  },
  cardFooter: {
    backgroundColor: '#ecf0f1',
    padding: '10px 20px',
    textAlign: 'center',
    borderTop: '1px solid #e0e0e0',
  },
  footerText: {
    margin: 0,
    color: '#7f8c8d',
    fontSize: '0.9rem',
  },
  paymentContainer: {
    marginBottom: '30px'
  },
  step: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '25px',
  },
  stepNumber: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '24px',
    height: '24px',
    backgroundColor: '#4CAF50',
    color: 'white',
    borderRadius: '50%',
    marginRight: '10px',
    fontWeight: 'bold'
  },
  stepText: {
    fontSize: '16px',
    fontWeight: 'bold'
  },
  paymentMethods: {
    marginBottom: '30px'
  },
  paymentOption: {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 15px',
    marginBottom: '10px',
    borderRadius: '5px',
    cursor: 'pointer',
    border: '1px solid #ddd',
    transition: 'all 0.3s ease'
  },
  paymentOptionSelected: {
    backgroundColor: '#e8f5e9',
    borderColor: '#4CAF50'
  },
  radioInput: {
    marginRight: '10px'
  },
  amountInput: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ddd',
    marginBottom: '20px'
  },
  continueButton: {
    width: '100%',
    padding: '12px',
    backgroundColor: '#4CAF50',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease',
    fontFamily: 'Montserrat, sans-serif'
  },
  continueButtonDisabled: {
    backgroundColor: '#cccccc',
    cursor: 'not-allowed'
  }
};

const styleSheet = document.styleSheets[0];
const keyframes = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
`;
styleSheet.insertRule(keyframes, styleSheet.cssRules.length);

export default BalanceRecharge;